// `video.talking_head_advanced`: one actor of live's Talking Head with Advanced on (#223).
// Live's video list; the Talking Head form starts these with Advanced on, not a Studio draft.
import {
  VideoTalkingHeadAdvancedQuote,
  VideoTalkingHeadAdvancedRequest,
} from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.talking_head_advanced"> = {
  type: "video.talking_head_advanced",
  label: "Advanced Talking Head",
  source: "form",
  pair: "video.talking_head_advanced",
  fields: () => ({}),
  request: VideoTalkingHeadAdvancedRequest,
  quote: VideoTalkingHeadAdvancedQuote,
};
